import { BaseURL } from "../config/apiUrl";
import RenderToast from "../components/RenderToast";
import axios from "axios";
import { signOutRequest } from "../store/auth/authSlice";

/**
 * @deprecated use ConfiguredAxios instead.
 * @description Sends a Get request to api
 * @param {String} route
 * @example "/api/route"
 * @returns Promise<any>
 */

const Get = async ({
  route,
  accessToken,
  showAlert = true,
  dispatch,
  responseType = null,
}) => {
  const options = accessToken
    ? {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        responseType,
      }
    : {
        headers: {
          Accept: "application/json",
        },
        responseType,
      };
  try {
    const response = await axios.get(BaseURL(route), options);
    return [response, true];
  } catch (error) {
    if (showAlert == false) {
      return;
    }
    let formError =
      Array.isArray(error?.response?.data?.errors) ||
      error?.response?.data?.errors?.error
        ? false
        : true;
    let errorMessage = "";
    if (formError) {
      // create foreach loop on object to get the error message
      Object.keys(error?.response?.data?.errors).forEach((key) => {
        errorMessage = `${errorMessage} ➤ ${error?.response?.data?.errors[key]} \n`;
      });
    } else {
      errorMessage = error?.response?.data?.message;
    }
    if (error?.response?.status === 401) {
      dispatch && dispatch(signOutRequest());
    }
    if (error?.message === "Network Error") {
      RenderToast({
        type: "error",
        message: `${error?.message} : Please Check Your Network Connection`,
      });
    } else {
      RenderToast({
        type: "error",
        message: errorMessage,
        ...(formError && { icon: false }),
      });
    }
    return [error?.response, false];
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 * @returns Promise<any>
 */

const Post = async ({
  route,
  data = {},
  headers,
  showAlert = true,
  dispatch,
}) => {
  try {
    const response = await axios.post(BaseURL(route), data, headers);
    return [response, true];
  } catch (error) {
    if (showAlert == false) {
      return;
    }
    let formError =
      Array.isArray(error?.response?.data?.errors) ||
      error?.response?.data?.errors?.error
        ? false
        : true;
    let errorMessage = "";
    if (formError) {
      // create foreach loop on object to get the error message
      Object.keys(error?.response?.data?.errors).forEach((key) => {
        errorMessage = `${errorMessage} ➤ ${error?.response?.data?.errors[key]} \n`;
      });
    } else {
      errorMessage = error?.response?.data?.message;
    }
    if (error?.response?.status === 401) {
      dispatch && dispatch(signOutRequest());
    }
    if (error?.message === "Network Error") {
      RenderToast({
        type: "error",
        message: `${error?.message} : Please Check Your Network Connection`,
      });
    } else {
      RenderToast({
        type: "error",
        message: errorMessage,
        ...(formError && { icon: false }),
      });
    }
    return [error?.response, false];
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

const Patch = async ({
  route,
  data = {},
  headers,
  showAlert = true,
  dispatch,
}) => {
  try {
    const response = await axios.patch(BaseURL(route), data, headers);
    return [response, true];
  } catch (error) {
    if (showAlert == false) {
      return;
    }
    let formError =
      Array.isArray(error?.response?.data?.errors) ||
      error?.response?.data?.errors?.error
        ? false
        : true;
    let errorMessage = "";
    if (formError) {
      // create foreach loop on object to get the error message
      Object.keys(error?.response?.data?.errors).forEach((key) => {
        errorMessage = `${errorMessage} ➤ ${error?.response?.data?.errors[key]} \n`;
      });
    } else {
      errorMessage = error?.response?.data?.message;
    }
    if (error?.response?.status === 401) {
      dispatch && dispatch(signOutRequest());
    }
    if (error?.message === "Network Error") {
      RenderToast({
        type: "error",
        message: `${error?.message} : Please Check Your Network Connection`,
      });
    } else {
      RenderToast({
        type: "error",
        message: errorMessage,
        ...(formError && { icon: false }),
      });
    }
    return [error?.response, false];
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

const Put = async ({
  route,
  data = {},
  headers,
  showAlert = true,
  dispatch,
}) => {
  try {
    const response = await axios.put(BaseURL(route), data, headers);
    return [response, true];
  } catch (error) {
    if (showAlert == false) {
      return;
    }
    let formError =
      Array.isArray(error?.response?.data?.errors) ||
      error?.response?.data?.errors?.error
        ? false
        : true;
    let errorMessage = "";
    if (formError) {
      // create foreach loop on object to get the error message
      Object.keys(error?.response?.data?.errors).forEach((key) => {
        errorMessage = `${errorMessage} ➤ ${error?.response?.data?.errors[key]} \n`;
      });
    } else {
      errorMessage = error?.response?.data?.message;
    }
    if (error?.response?.status === 401) {
      dispatch && dispatch(signOutRequest());
    }
    if (error?.message === "Network Error") {
      RenderToast({
        type: "error",
        message: `${error?.message} : Please Check Your Network Connection`,
      });
    } else {
      RenderToast({
        type: "error",
        message: errorMessage,
        ...(formError && { icon: false }),
      });
    }
    return [error?.response, false];
  }
};

/**
 * @description Sends a Delete request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

const Delete = async ({ route, data, headers, showAlert = true, dispatch }) => {
  try {
    const dataAndHeader = {
      ...(data && { data }),
      ...(headers && { headers }),
    };
    const response =
      data == null
        ? await axios.delete(BaseURL(route), headers)
        : await axios.delete(BaseURL(route), dataAndHeader);
    return [response, true];
  } catch (error) {
    if (showAlert == false) {
      return;
    }
    let formError =
      Array.isArray(error?.response?.data?.errors) ||
      error?.response?.data?.errors?.error
        ? false
        : true;
    let errorMessage = "";
    if (formError) {
      // create foreach loop on object to get the error message
      Object.keys(error?.response?.data?.errors).forEach((key) => {
        errorMessage = `${errorMessage} ➤ ${error?.response?.data?.errors[key]} \n`;
      });
    } else {
      errorMessage = error?.response?.data?.message;
    }
    if (error?.response?.status === 401) {
      dispatch && dispatch(signOutRequest());
    }
    if (error?.message === "Network Error") {
      RenderToast({
        type: "error",
        message: `${error?.message} : Please Check Your Network Connection`,
      });
    } else {
      RenderToast({
        type: "error",
        message: errorMessage,
        ...(formError && { icon: false }),
      });
    }
    return [error?.response, false];
  }
};

export { Post, Put, Get, Patch, Delete };
